import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import keycloak from './services/auth/keycloak';
import { useAuthStore } from './stores/authStore';
import App from './App';
import { setupErrorFilter } from './utils/errorFilter';
import './i18n';
import './styles/globals.css';
import './components/common/styles/entity-form.css';

setupErrorFilter();

const rootEl = document.getElementById('root')!;

keycloak
  .init({
    onLoad: 'check-sso',
    pkceMethod: 'S256',
    checkLoginIframe: false,
    silentCheckSsoFallback: false,
  })
  .then((authenticated) => {
    if (authenticated) {
      useAuthStore.getState().setFromKeycloak(keycloak);

      // Token refresh every 4 min
      setInterval(() => {
        keycloak.updateToken(120).then((refreshed) => {
          if (refreshed) {
            useAuthStore.getState().setFromKeycloak(keycloak);
          }
        }).catch(() => {
          useAuthStore.getState().logout();
        });
      }, 240000);
    }

    // Mount React regardless — App handles auth routing
    ReactDOM.createRoot(rootEl).render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
  })
  .catch(() => {
    // Keycloak unavailable — mount anyway, login page will show error
    ReactDOM.createRoot(rootEl).render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
  });
